<script>
import { mapState } from 'vuex'

export default {
  name: 'MfFetching',
  computed: {
    ...mapState({
      fetching: state => state.fetching
    })
  }
}
</script>

<template lang="html">
  <div v-if="fetching">
    <div class="modal fade in is-show">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <h4 class="text-center">
              <i class="fa fa-spinner fa-pulse fa-fw"></i> Aguarde...
            </h4>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade in"></div>
  </div>
</template>

<style lang="css">
  .is-show {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/fetching.vue